// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1OHx7","col":"styles_col__248Jm"};